import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseStatusViewComponent } from '../base-status-view.component';
import { Kontrolltermin } from '../../../services/kontrolltermin.service';

@Component({
  selector: 'app-fehlerhaft-view',
  templateUrl: './fehlerhaft-view.component.html',
  styleUrls: ['./fehlerhaft-view.component.scss']
})
export class FehlerhaftViewComponent extends BaseStatusViewComponent implements OnInit {
  
  constructor(
    private router: Router,
    formBuilder: FormBuilder
  ) {
    super(formBuilder);
  }
  
  getStatusTitle(): string {
    return 'Fehlerhafter Kontrolltermin';
  }
  
  getAvailableActions(): string[] {
    return []; // No actions possible - read-only info
  }
  
  getFormFields(): any[] {
    return []; // No form fields - read-only
  }
  
  onSave(): void {
    // No save action for fehlerhaft
    console.log('⚠️ FEHLERHAFT: No save action available');
  }
  
  onCancel(): void {
    this.logAction('Cancel');
    console.log('⚠️ FEHLERHAFT: Cancel action triggered');
    this.router.navigate(['/kontrolltermine']);
  }
  
  onStatusChange(newStatus: string): void {
    // No status change possible for fehlerhaft
    console.log('⚠️ FEHLERHAFT: No status change possible');
  }
}
